import { createContext, useContext, useState, useEffect, ReactNode } from 'react'
import { lumi } from '../lib/lumi'

interface EditModeContextType {
  isEditMode: boolean
  setIsEditMode: (v: boolean) => void
  isAdmin: boolean
  user: any
}

const EditModeContext = createContext<EditModeContextType>({
  isEditMode: false,
  setIsEditMode: () => {},
  isAdmin: false,
  user: null,
})

export const useEditMode = () => useContext(EditModeContext)

export const EditModeProvider = ({ children }: { children: ReactNode }) => {
  const [isEditMode, setIsEditMode] = useState(false)
  const [user, setUser] = useState<any>(lumi.auth.user)

  useEffect(() => {
    const unsubscribe = lumi.auth.onAuthChange(({ user: newUser }) => {
      setUser(newUser)
      if (!newUser || newUser.userRole !== 'ADMIN') {
        setIsEditMode(false)
      }
    })
    return () => unsubscribe()
  }, [])

  const isAdmin = user?.userRole === 'ADMIN'

  return (
    <EditModeContext.Provider value={{ isEditMode, setIsEditMode, isAdmin, user }}>
      {children}
    </EditModeContext.Provider>
  )
}
